import React, { ReactNode } from 'react';
import {
  Copy,
  Flex,
  Stack,
  Heading,
  StackSpace,
} from '@grubhubprod/gh-cookbook-react';

export interface ConfirmationSummaryRowProps {
  label: string;
  children: ReactNode;
  y?: StackSpace;
}

export function ConfirmationSummaryRow({
  label,
  children,
  y = 'xxx-sm',
}: ConfirmationSummaryRowProps): JSX.Element {
  return (
    <Stack y={y}>
      <Flex alignItems="flex-start">
        <Stack flexBasis="90px" flexShrink={0}>
          <Heading variant="h6">{label}</Heading>
        </Stack>
        <Stack flex={1}>
          <Copy variant="body">{children}</Copy>
        </Stack>
      </Flex>
    </Stack>
  );
}
